module.exports = __webpack_public_path__ + "img/P150T_weapon_151.78376170.png";